import { render, staticRenderFns } from "./NormalSearchNav196.vue?vue&type=template&id=f97a175a&scoped=true"
import script from "./NormalSearchNav196.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav196.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97a175a",
  null
  
)

export default component.exports